import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PostAPI } from "../../Components/Backend/PostAPI";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { Grid } from "@mui/material";
import UserDashboard from "../UserDashboard/UserDashboard";
import UserCard from "./UserCard";
import APIAxios from "../../Api/APIAxios";
import SessaoAuth from "../../Hooks/SessaoAuth";
import PageTitle from "../../components/Layout/PageTitle";

const URL_Produtividade = "/resumo/produtividade";
const URLAvatar = "/colab/avatar";

const calculateOverallProductivity = (users) => {
  if (users.length === 0) return 0;

  const total = users.reduce((sum, user) => sum + user.minTotal, 0);

  const registrado = users.reduce((sum, user) => sum + user.minRegistrados, 0);

  return (registrado * 100) / total > 100
    ? 100
    : ((registrado * 100) / total).toFixed(2);
};

const UserMonitoring = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(7); //Monitoramento
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();

  const { sessao } = SessaoAuth();
  const [selectedUser, setSelectedUser] = useState(null);

  const [usuarios, setUsuarios] = useState([]);
  const [computador, setComputador] = useState("*");
  const [avatarCache, setAvatarCache] = useState([]);

  //Parte para voltar para os outros usuários se clicar no menu lateral
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/produtividade" && location.state?.reset) {
      setSelectedUser(null); // volta para o grid
    }
  }, [location.pathname, location.state?.reset]);

  const loadProdutividade = async () => {
    setLoading(true);

    const response = await PostAPI(apiAxios, URL_Produtividade, {
      data_inicio: sessao.dataIni,
      data_fim: sessao.dataFim,
      computador,
    });
    setLoading(false);

    if (!response.success) {
      setAvisoErro(response.errorMessage || "Erro ao carregar colaboradores.");
    } else {
      // Atualiza os usuários com os avatares
      await atualizarUsuariosComAvatar(response.data);
    }
  };

  useEffect(() => {
    loadProdutividade();
  }, [sessao]);

  const carregarAvatar = async (id) => {
    // Verifica se o avatar já está no cache
    const cacheEntry = avatarCache.find((entry) => entry.id === id);

    if (cacheEntry) {
      return cacheEntry.url; // Retorna a URL do cache se já existir
    }

    setLoading(true);

    try {
      const response = await apiAxios.get(`${URLAvatar}/${id}`, {
        responseType: "blob", // receber Imagem
      });
      const avatarURL = URL.createObjectURL(response.data);

      setAvatarCache((prev) => {
        const alreadyCached = prev.find((entry) => entry.id === id);
        if (!alreadyCached) {
          return [...prev, { id, url: avatarURL }];
        }
        return prev;
      });

      return avatarURL;
    } catch (err) {
      if (!err.response) {
        setAvisoErro("Servidor não responde");
      } else if (err.response.status === 400 || err.response.status === 401) {
        setAvisoErro(err.response.data.erro);
      }
    } finally {
      setLoading(false);
    }
  };

  const atualizarUsuariosComAvatar = async (usuarios) => {
    const usuariosAtualizados = await Promise.all(
      usuarios.map(async (usuario) => {
        const avatar = await carregarAvatar(usuario.idColaborador);
        return { ...usuario, avatar };
      }),
    );
    setUsuarios(usuariosAtualizados);
  };

  const atualizarSelUser = () => {
    let encontrou = false;
    if (selectedUser) {
      usuarios.map((user) => {
        if (user.idColaborador === selectedUser.idColaborador) {
          encontrou = true;
          setSelectedUser(user);
        }
      });

      if (!encontrou) {
        setSelectedUser();
      }
    }
  };

  useEffect(() => {
    atualizarSelUser();
  }, [usuarios]);

  const overallProductivity = calculateOverallProductivity(usuarios);

  return (
    <div>
      {selectedUser ? (
        <UserDashboard
          user={selectedUser}
          overallProductivity={overallProductivity}
          setSelectedUser={setSelectedUser}
          usuarios={usuarios}
        />
      ) : (
        <>
          {/***************************************** AVISOS **********************************/}
          <PageTitle
            caption="Colaboradores"
            setAvisoErro={setAvisoErro}
            avisoErro={avisoErro}
            avisoSucesso={avisoSucesso}
            setAvisoSucesso={setAvisoSucesso}
            loading={loading}
            accentStyle
          />
          {/***************************************** AVISOS **********************************/}
          <Grid container spacing={2}>
            {usuarios.map((usuario) => (
              <Grid
                item
                xs={12}
                md={6}
                key={usuario.id}
                sx={{display:"flex", justifyContent:"center"}}
              >
                <UserCard user={usuario} onClick={() => setSelectedUser(usuario)} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  );
};

export default UserMonitoring;
